module.exports = __webpack_public_path__ + "static/venus-16-eac4ff080b8c8bb812a6bfdf7256bd57.jpg";